import { trigger, transition, style, animate, query, animateChild } from '@angular/animations';
import { Component, OnInit, Injector } from '@angular/core';
import { BootstrapContinentalRankingComponent } from 'src/app/continental-ranking/components/bootstrap-continental-ranking/bootstrap-continental-ranking.component';
import { WorldRankingFiltersService } from '../../services/world-ranking-filters.service';
import { animationsTable } from '../../../../common-page-components/wa-table/wa-table.component';
import { map, combineLatest, mergeMap } from 'rxjs/operators';
import { WorldRankingStore } from '../../../../common-page-components/stores/entities-store/worldranking-store';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-world-ranking-bootstrap',
  templateUrl: '../../../../continental-ranking/components/bootstrap-continental-ranking/bootstrap-continental-ranking.component.html',
  styleUrls: ['../../../../continental-ranking/components/bootstrap-continental-ranking/bootstrap-continental-ranking.component.scss'],
  animations:[animationsTable]
})
export class WorldRankingBootstrapComponent extends BootstrapContinentalRankingComponent implements OnInit {

  constructor(public world_ranking_service: WorldRankingFiltersService, injector:Injector) {
    super(injector, world_ranking_service as any);
    this.model = new WorldRankingStore(injector.get(HttpClient));
    this.ShowNoResultsBox = false;
  }


  /**
   * {@inheritdoc}
   *
   * @memberof WorldRankingBootstrapComponent
   */
  ngOnInit() {
    (this.filter_service as WorldRankingFiltersService).getDataStreamWithFilters()
    .pipe(
      combineLatest([this.reload.asObservable()]),

      map(([a,b])=> a),
      map(([order, text, category, date, discipline, country, individualTeam]) => {
        if (category['Name'].includes('Team') && individualTeam.Name === 'Team') {
          this.headerName = `${category['Name']}`;
        } else {
          this.headerName = `${category['Name']} ${this.translationService.translate(individualTeam.Name)}`;
        }
        const params = {
          fText: text.text,
          SortBy: order.sortingSend,
          CatCode: category['Code'],
          Country: country['NOC'],
          Detailed:1,
          Team: individualTeam.Value === true ? 1 : undefined,
          Date: date.value
          ? String(
            new Date(
              date.value.value.getTime() -
              date.value.value.getTimezoneOffset() * 60000
            )
              .toISOString()
              .slice(0, 10)
          )
          : undefined,
        };
        return params;
      }),
      mergeMap(params => this.model.requestData(params, this.request_more_data))
      )
    .subscribe(next=> {
    })
  }


}
